import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

export const noAuthGuard = () => {
	const authService = inject(AuthService);
	const router = inject(Router);

	/**
	 * Protects public routes from authenticated users.
	 * Redirects to a protected route if the user is authenticated.
	 */
	if (authService.isAuthenticated()) {
		router.navigate(['/boost']);
		return false;
	}

	//console.log('✅ Unauthenticated user, allowing access to public route');
	return true;
};

// Keep class for compatibility if needed
export class NoAuthGuard {
	constructor(
		protected authService: AuthService,
		private router: Router,
	) {}

	/**
	 * Protects public routes from authenticated users.
	 * Redirects to a protected route if the user is authenticated.
	 */
	canActivate(): boolean {
		//console.log('🛡️ NoAuthGuard activated at:', this.router.url);

		if (this.authService.isAuthenticated()) {
			//console.log('🚫 Authenticated user trying to access public route');
			this.router.navigate(['/boost']);
			return false;
		}

		//console.log('✅ Unauthenticated user, allowing access to public route');
		return true;
	}
}
